/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleasePdfFileSuccessResponseData,
    PostPressReleasePdfFileSuccessResponseDataFromJSON,
    PostPressReleasePdfFileSuccessResponseDataFromJSONTyped,
    PostPressReleasePdfFileSuccessResponseDataToJSON,
} from './PostPressReleasePdfFileSuccessResponseData';

/**
 * POST /press_release/{release_id}/pdf_file
 * @export
 * @interface PostPressReleasePdfFileResponse
 */
export interface PostPressReleasePdfFileResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleasePdfFileResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleasePdfFileResponse
     */
    message: string;
    /**
     * 
     * @type {PostPressReleasePdfFileSuccessResponseData}
     * @memberof PostPressReleasePdfFileResponse
     */
    data: PostPressReleasePdfFileSuccessResponseData;
}

export function PostPressReleasePdfFileResponseFromJSON(json: any): PostPressReleasePdfFileResponse {
    return PostPressReleasePdfFileResponseFromJSONTyped(json, false);
}

export function PostPressReleasePdfFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleasePdfFileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPressReleasePdfFileSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostPressReleasePdfFileResponseToJSON(value?: PostPressReleasePdfFileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPressReleasePdfFileSuccessResponseDataToJSON(value.data),
    };
}

